var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { title: "User profile", closable: "" } },
    [
      !_vm.submitCompleted
        ? [
            _c("ui-input", {
              attrs: { readonly: "", label: "First Name" },
              model: {
                value: _vm.fname,
                callback: function ($$v) {
                  _vm.fname = $$v
                },
                expression: "fname",
              },
            }),
            _vm._v(" "),
            _c("ui-input", {
              attrs: { readonly: "", label: "Last Name" },
              model: {
                value: _vm.lname,
                callback: function ($$v) {
                  _vm.lname = $$v
                },
                expression: "lname",
              },
            }),
            _vm._v(" "),
            _c("ui-input", {
              attrs: { readonly: "", label: "E-mail" },
              model: {
                value: _vm.email,
                callback: function ($$v) {
                  _vm.email = $$v
                },
                expression: "email",
              },
            }),
            _vm._v(" "),
            _c(
              "ui-dialog-footer",
              [
                _c("ui-button", {
                  attrs: {
                    disabled: _vm.isProcessing,
                    primary: "",
                    text: "Reset password",
                    tooltip: "Request password reset link by email",
                  },
                  on: { click: _vm.forgotPassword },
                }),
              ],
              1
            ),
          ]
        : _c("p", { staticClass: "ui-body" }, [
            _vm._v(
              "\n\t\tAn email has been sent to you with instructions on how to change your password."
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("i", [
              _vm._v(
                "Tip: If you do not receive this email within a reasonable amount of time, please check your spam folder."
              ),
            ]),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }